import type { NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'
import { invitation } from '@/constants/invitation'

export const siteConfig: SiteConfig = {
    name: `Les ${invitation.age} ans de ${invitation.honoree}`,
    description: `${invitation.honoree} fête ses ${invitation.age} ans le ${invitation.date.full.toLowerCase()} à ${invitation.venue.city}. Programme de la soirée, infos pratiques et réponse en ligne en moins d’une minute.`,
    url: getOrigin()
}

export const navLinks: Array<NavLink> = [
    { href: '/#le-mot', label: "Le mot" },
    { href: '/#programme', label: "Programme" },
    { href: '/#infos', label: "Infos pratiques" },
    { href: '/#faq', label: "FAQ" }
]
